import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

export default function useMobileWebAppPromo({ enabled }) {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!enabled || dismissed) {
      return undefined;
    }

    let cancelled = false;

    const loadStatus = async () => {
      setLoading(true);
      try {
        const response = await axios.get('/api/mobile-login/status', {
          withCredentials: true,
        });
        if (cancelled) return;

        const hasEverUsed = Boolean(response.data?.hasEverUsed);
        setVisible(!hasEverUsed);
      } catch (err) {
        console.error('[useMobileWebAppPromo] status load failed:', err);
        if (!cancelled) setVisible(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadStatus();

    return () => {
      cancelled = true;
    };
  }, [enabled, dismissed]);

  const dismiss = useCallback(() => {
    setDismissed(true);
    setVisible(false);
  }, []);

  return {
    visible: visible && !loading && !dismissed,
    loading,
    dismiss,
  };
}
